import { startOfToday, subDays, subYears } from 'date-fns';

interface DateRange {
  from: Date | null;
  to: Date | null;
}
export const handlePeriodSelection = (period: string): DateRange => {
  const today = startOfToday();

  switch (period) {
    case 'today':
      return {
        from: today,
        to: today,
      };
    case 'yesterday': {
      const date = subDays(today, 1);
      return {
        from: date,
        to: date,
      };
    }
    case 'last7days':
      return {
        from: subDays(today, 6), // includes today
        to: today,
      };
    case 'last30days':
      return {
        from: subDays(today, 29),
        to: today,
      };
    case 'last90days':
      return {
        from: subDays(today, 89),
        to: today,
      };
    case 'lifetime':
      return {
        from: null,
        to: null,
      };
    default:
      return {
        from: null,
        to: null,
      };
  }
};
